// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1e6e5461","855":"953e1d8d"}[chunkId] + ".chunk.js";
};